import { useEffect, useState } from "react";
import Layout from "../../../components/custom/Layout";
import VirtualTable from "../../../components/custom/VirtualTable";
import apiClient from "../../../apiClient";
import { useAppContext } from "../../../context";
import { IAttendanceUpdate } from "../../../globals/interfaces";
import { getTsDate } from "../../../utils";
import _ from "lodash";
import ModalNotes from "./ModalNotes";
import moment from "moment";

interface ExtendedAttendanceUpdate extends IAttendanceUpdate {
    i_employee_number: number;
}

export default function AttendanceDiscrepancy () {

    const { user } = useAppContext();
    const [data, setData] = useState<Array<ExtendedAttendanceUpdate>>([]);
    const [item, setItem] = useState<IAttendanceUpdate>();
    const [modal, setModal] = useState(false);

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await apiClient.get(`/attendance/${user.s_unit}`);
                setData(res.data);
            } catch (err) {
                console.log(err);
            }
        }
        getData();
    }, [user.s_unit]);

    const addNotes = async (notes: string) => {
        if (!item) return;
        try {
            const body: Partial<IAttendanceUpdate> = {
                id: item.id, 
                notes, 
                modified: getTsDate(), 
                modifiedBy: user.s_email
            }
            await apiClient.put(`/attendance`, body);
            setData((prev) => {
                const copy = _.cloneDeep(prev);
                const updateIndex = copy.findIndex(i => i.id === item.id);
                for (const key in body) {
                    // @ts-ignore
                    copy[updateIndex][key] = body[key];
                }
                return copy;
            });
            setItem(prev => {
                const copy = _.cloneDeep(prev);
                for (const key in body) {
                    // @ts-ignore
                    copy[key] = body[key];
                }
                return copy;
            });
            setModal(false);
        } catch (err) {
            console.log(err);
        }
    }

    const handleUpdate = (item: IAttendanceUpdate) => {
        setItem(item);
        setModal(true);
    }

    return (
        <Layout>
            <h4>Attendance Discrepancy</h4>
            <VirtualTable<ExtendedAttendanceUpdate>
                data={data}
                mapping={[{
                    name: 'Date',
                    value: 'attendanceDate',
                    date: true,
                    utc: true,
                    sortMethod: (a, b) => +moment(a) - +moment(b)
                }, {
                    name: 'Phone # Entered',
                    value: 'cell',
                    customWidth: 100
                }, {
                    name: 'Employee #',
                    value: 'i_employee_number',
                    customWidth: 100
                },  {
                    name: 'Employee',
                    value: 'email',
                    email: true
                }, {
                    name: 'Type',
                    value: 'type'
                }, {
                    name: 'Department',
                    value: 'department'
                }, {
                    name: 'Position',
                    value: 'position'
                }, {
                    name: 'Reason',
                    value: 'reason'
                }, {
                    name: 'Created',
                    value: 'created',
                    datetime: true,
                    // utc: true **INTENTIONAL
                }, {
                    name: 'Notes',
                    value: 'fas fa-edit',
                    icon: true,
                    function: (item: IAttendanceUpdate) => handleUpdate(item)
                }]}
                numRows={10}
            />
            <ModalNotes 
                modal={modal}
                setModal={setModal}
                item={item}
                addNotes={addNotes}
            />
        </Layout>
    );
}